import React, { useState } from 'react';
import { styles } from './styles';
import { GLASS_BG, GLASS_BG_HOVER } from '../../globalStyles';

interface ServiceProps {
  index: string;
  icon: React.ReactNode;
  title: string;
  description: string;
}

const Service: React.FC<ServiceProps> = ({ index, icon, title, description }) => {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      style={{ ...styles.card, background: hovered ? GLASS_BG_HOVER : GLASS_BG }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div style={styles.top}>
        <div style={styles.icon}>{icon}</div>
        <span style={styles.index}>{index}</span>
      </div>
      <p style={styles.title}>{title}</p>
      <p style={styles.description}>{description}</p>
    </div>
  );
};

export default Service;
